import type { RowVariantDefinition } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'
import { defineRowVariantRegistry } from '@/deskUiSkeletons/rowTemplates/RowVariantRegistry'
import { sharedChatAnswerVariant } from '@/msgComponents/rowVariants/Chat/Chat'
import { productRowVariantForPath, productRowVariantsForPath } from '../../../productDisplayCatalog'
import { FacebookCommentTemplate } from './variants/FacebookComment'
import { FacebookSlideTemplate } from './variants/FacebookSlide'

const commentVariant = {
  ...productRowVariantForPath('facebook', 2),
  Template: FacebookCommentTemplate,
} as const satisfies RowVariantDefinition

const slideVariant = {
  ...productRowVariantForPath('facebook', 3),
  Template: FacebookSlideTemplate,
} as const satisfies RowVariantDefinition

const productRows = productRowVariantsForPath('facebook')

export const rowVariantRegistry = defineRowVariantRegistry({
  answers: {
    variants: [commentVariant, slideVariant, sharedChatAnswerVariant],
    fallback: productRows.answers.fallback,
  },
  submsges: {
    variants: [commentVariant, slideVariant],
    fallback: productRows.submsges.fallback,
  },
})
